import React, { FC, ReactNode } from 'react';
import {
  Collapse,
  ConfigProvider,
  Flex,
  theme,
  Typography,
} from '@duxton-web/ui';

import { TrackConf } from '../../../lib/App';
import { RolloutTrackConf } from '../RolloutEditor/RolloutTrackConf';
import { SecondaryText } from '@/common/components';
import { useRolloutContext } from '@/contexts/RolloutContext';

interface EventTrackingProps {
  disabled: boolean;
  showCostTable?: boolean;
  eventTrackingHeader?: string;
}

const defaultEventTrackingHeader = 'Event Tracking';

const EventTrackingV2: FC<EventTrackingProps> = ({
  disabled,
  eventTrackingHeader = 'Event Tracking',
}) => {
  // Get rollout state from context
  const { rollout, handleTrackConfChange } = useRolloutContext();

  function onRolloutTrackConfigChange(trackConf: TrackConf): void {
    handleTrackConfChange(trackConf);
  }

  function renderEventTrackingHeader(): ReactNode {
    return (
      <Flex vertical flex={1}>
        <Typography.Text strong>
          {!eventTrackingHeader
            ? defaultEventTrackingHeader
            : `${eventTrackingHeader}`}
        </Typography.Text>
        <SecondaryText>
          Keep at 1% unless you need to analyse all rollout events. See
          go/grabx-rollout-events-tracking for more information.
        </SecondaryText>
      </Flex>
    );
  }

  function renderRolloutTrackConf(): ReactNode {
    return (
      <RolloutTrackConf
        trackConf={rollout?.trackConf}
        onChange={onRolloutTrackConfigChange}
        disabled={disabled}
      />
    );
  }

  return (
    <ConfigProvider
      theme={{
        components: {
          Collapse: {
            headerBg: theme.getDesignToken().white,
          },
        },
      }}
    >
      <Collapse
        expandIconPosition="end"
        style={{
          marginBottom: 16,
        }}
      >
        <Collapse.Panel
          key="1"
          header={renderEventTrackingHeader()}
          className="rollout-tab__panel"
        >
          {renderRolloutTrackConf()}
        </Collapse.Panel>
      </Collapse>
    </ConfigProvider>
  );
};

export default EventTrackingV2;
